export default "__VITE_ASSET__C$HoNdUW__"